import $ from 'jquery';

$(() => {
  if (document.getElementById('nicotineWarning')) {
    run();
    window.addEventListener('scroll', run);
    window.addEventListener('resize', run);
  }
});

const run = () => {
  updateStickyNav();
};

const updateStickyNav = () => {
  const offset = document.getElementById('nicotineWarning').offsetHeight;
  const bodyContent = document.getElementsByClassName('body__content')[0];

  if (window.pageYOffset >= offset) {
    // headers stick to the top once the nicotine warning scrolls off the page
    headerPosition('fixed');
    bodyContent.classList.remove('no-padding');
  } else {
    // headers scroll with page when nicotine warning is visible
    headerPosition('relative');
    bodyContent.classList.add('no-padding');
  }
};

const headerPosition = position => {
  const headers = document.getElementsByClassName('header__nav-wrapper');
  Array.prototype.forEach.call(headers, el => {
    el.style.position = position;
  });
};
